import FullScreenLayout from '../../layouts/FullScreenLayout'
import Logout from './Logout'

export default FullScreenLayout(Logout)
